import { useCallback } from 'react';
import { BasicItemMenuButton } from '../common';
import type { GroupMemberInvitation } from '@group/domain';
import { toast } from 'react-hot-toast';
import { trpcClient } from '@framework/trpcClient';
import { TRPCClientError } from '@trpc/client';
import { createErrorMessage } from '@framework/utils/createErrorMessage';
import { useTranslation } from 'react-i18next';

type Props = {
  invitations: {
    whole: GroupMemberInvitation[];
    selected: GroupMemberInvitation;
  };
};

export const ReinviteMenuButton: React.FC<Props> = ({ invitations }: Props) => {
  const { t } = useTranslation();
  const handleReinvite = useCallback(async () => {
    const { whole, selected } = invitations;

    let isInvitationAccepted = false;
    for (const i of whole) {
      if (i.invitation.email === selected.invitation.email) {
        if (i.isAccepted()) {
          isInvitationAccepted = true;
          break;
        }
      }
    }

    if (isInvitationAccepted) {
      toast.error(t('group.invitations.reinvite.alreadyAccepted'));
      return;
    }

    try {
      const groupId = selected.groupId;
      const orgInvitationId = selected.id;
      await trpcClient.group.resendGroupMemberInvitation.mutate({ groupId, orgInvitationId });
      toast.success(t('group.invitations.reinvite.success'));
    } catch (e) {
      if (e instanceof TRPCClientError) {
        toast.error(createErrorMessage(e, t('group.invitations.reinvite.error')));
      } else {
        throw e;
      }
    }
  }, [invitations, t]);

  return <BasicItemMenuButton menuTitle={t('group.invitations.reinvite.menuTitle')} onClickMenu={handleReinvite} />;
};
